import { createSlice } from "@reduxjs/toolkit";
import { fetchReportsList } from "./reportIndicatorsApi"; // Import the downloadFile thunk

interface reportsData {
    embedtoken: string;
    embedUrl: string;
    reportId: string;
    // Add any other properties in indicatorsData here
}
interface UsersState {
    reportsData: reportsData;
    isLoading: boolean;
    error: any;
}

const initialState: UsersState = {
    reportsData: { embedtoken: "", embedUrl: "", reportId: "" },
    isLoading: false,
    error: null,
};

const reportIndicatorsSlice = createSlice({
    name: "indicatorsData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchUsers actions
            .addCase(fetchReportsList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchReportsList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.reportsData = action?.payload?.data || [];
            })
            .addCase(fetchReportsList.rejected, (state, action) => {
                console.log('error', action.payload);
                state.isLoading = false;
            })


    },
});

export default reportIndicatorsSlice.reducer;
